import React from 'react';
import { PwaInstallBanner } from '@/components/compose/pwa.install.banner';

export function PwaInstallProvider({ children }: { children: React.ReactNode }) {
  // Always render children so the main app tree is never missing!
  return (
    <>
      {children}
      <PwaInstallBanner />
    </>
  );
}
